import React from 'react';
import './App.css';

// import components
import Header from "./components/Header";
import BottomNav from "./components/BottomNav";

// import react-router-dom
import {Route, Switch} from "react-router-dom"

// import pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";

function App() {
  return (
    <div className="App">
      <Header/>
      <main>
        <Switch>
          <Route exact path="/home" component={Home}/>
          <Route exact path="/about" component={About}/>
          <Route exact path="/services" component={Services}/>
          <Route exact path="/contact" component={Contact}/>
        </Switch>
      </main>
      <BottomNav/>
    </div>    
  );
}

export default App;
